import clsx from "clsx";
import { twMerge } from "tailwind-merge";
// Material UI
import { Box, BoxProps, SvgIcon, SvgIconProps, Tooltip, TooltipProps } from "@mui/material";
// Icons
import { ReactComponent as CoinsIcon } from "@/assets/icons/common/Coins.svg";

interface ICoinProps extends BoxProps {
	active: boolean;
	activeText?: string;
	inactiveText?: string;
	iconClassName?: string;
	tooltipProps?: TooltipProps;
	iconProps?: SvgIconProps;
}

export const Coin = (props: Readonly<ICoinProps>) => {
	const { active, activeText, inactiveText, iconClassName, iconProps, tooltipProps, ...boxProps } = props;

	return (
		<Tooltip
			title={active ? activeText : inactiveText}
			{...tooltipProps}
			slotProps={{
				tooltip: {
					sx: {
						fontSize: "0.75rem",
						fontFamily: "PT Sans Pro Narrow, sans-serif",
						fontWeight: 500,
					},
				},
			}}
		>
			<Box {...boxProps}>
				<SvgIcon
					inheritViewBox
					component={CoinsIcon}
					{...iconProps}
					className={twMerge(
						clsx("[&_path]:fill-current text-neutral-gray !w-[unset] !h-[unset]", {
							"text-success": active,
						}),
						iconClassName
					)}
				/>
			</Box>
		</Tooltip>
	);
};
